import InitialSearchDialog from './components/InitialSearchDialog';
import { useDialogState } from './hooks';

export default function BaoCaoBanHangNhomTheo2ChiTieu() {
  const {
    initialSearchDialogOpen,

    handleInitialSearchClose,
    handleInitialSearch
  } = useDialogState();

  return (
    <div className='flex h-full min-h-[calc(100vh-64px)] w-screen flex-col overflow-auto'>
      <InitialSearchDialog
        open={initialSearchDialogOpen}
        onClose={handleInitialSearchClose}
        onSearch={handleInitialSearch}
      />
    </div>
  );
}
